import React from "react";
import { Form, Formik } from "formik";
import { useOnSubmitFormik } from "api/hooks/useOnSubmitFormik";
import { Collections } from "api/model/Collections";
import * as Yup from "yup";
import { Brand, BrandFormDefault } from "api/model/Brand";
import { Box, Button, Grid } from "@material-ui/core";
import { InputFieldFormik } from "ui/componentes/Form/InputFieldFormik";
import { BoxCard } from "ui/componentes/BoxCard";
import { SubmitButton } from "ui/componentes/SubmitButton";
import {
    yupMaxLengthField,
    yupRequiredField,
} from "ui/componentes/Form/functions";
import { BucketFolders } from "api/constants";
import { FileVisualizer } from "ui/componentes/FileVisualizer";

interface BrandFormProps {
    brand?: Brand;
    onSave?: (id) => void;
    onCancel?: () => void;
}

export const BrandFormValidation = Yup.object().shape({
    name: Yup.string().required(yupRequiredField).max(50, yupMaxLengthField),
});

const BrandForm: React.FC<BrandFormProps> = ({ onCancel, brand, onSave }) => {
    const onSubmit = useOnSubmitFormik<Brand>(Collections.BRANDS, {
        callback: (id) => onSave && onSave(id),
    });

    return (
        <Formik
            enableReinitialize={true}
            initialValues={brand || BrandFormDefault}
            onSubmit={onSubmit}
            validationSchema={BrandFormValidation}
        >
            {({ values, submitForm }) => {
                return (
                    <Form>
                        <BoxCard display="flex">
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <InputFieldFormik
                                        id="name"
                                        name="name"
                                        label="Nome"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FileVisualizer
                                        label="Logo"
                                        file={values.image}
                                        uploadProps={{
                                            name: "image",
                                            accept: "image/*",
                                            folder: BucketFolders.BRANDS,
                                            disabled: !values.id,
                                            onComplete: () => submitForm(),
                                        }}
                                        onDelete={() => submitForm()}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Box
                                        display="flex"
                                        flexDirection="row-reverse"
                                        justifyContent=""
                                    >
                                        <SubmitButton
                                            style={{
                                                marginLeft: 5,
                                            }}
                                            fullWidth={false}
                                        >
                                            {values.id ? "Atualizar" : "Salvar"}
                                        </SubmitButton>
                                        <Button
                                            onClick={onCancel}
                                            fullWidth={false}
                                        >
                                            Cancelar
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </BoxCard>
                    </Form>
                );
            }}
        </Formik>
    );
};

export { BrandForm };
